module.exports = __webpack_public_path__ + "img/image-placeholder.3de0fb21.png";